"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgRoadOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M11 19v-3h2v5h-2.001v-2H11zm2-9v4h-2v-4h2zm2-4.69L14.377 3h.356c1.029 0 1.925.703 2.175 1.704l4.058 14.898A1.126 1.126 0 0119.88 21h-.61l-.54-2L15 5.31zM13 3v5h-2V3h2zM4.73 21h-.609a1.125 1.125 0 01-1.087-1.398L7.092 4.704A2.243 2.243 0 019.267 3h.356L9 5.31 5.27 19l-.54 2z' }))); };
exports.default = SvgRoadOutline;
//# sourceMappingURL=RoadOutline.js.map